import { Component, ElementRef, ViewContainerRef, ChangeDetectionStrategy, OnInit, AfterViewInit, OnDestroy, AfterContentChecked } from '@angular/core';
import { addClass } from '@syncfusion/ej2-base';
import { ComponentBase, IComponentBase, ComponentMixins, setValue } from '@syncfusion/ej2-angular-base';
import { RecurrenceEditor } from '@syncfusion/ej2-angular-schedule';

export const inputs: string[] = ['calendarMode', 'cssClass', 'dateFormat', 'enablePersistence', 'enableRtl', 'firstDayOfWeek', 'frequencies', 'locale', 'maxDate', 'minDate', 'selectedType', 'startDate', 'value'];
export const outputs: string[] = ['change'];
export const twoWays: string[] = [];

/**
 * `ejs-recurrenceeditor` represents the Angular RecurrenceEditor Component.
 * ```html
 * <ejs-recurrenceeditor></ejs-recurrenceeditor>
 * ```
 */
@Component({
    selector: 'app-ejs-recurrenceeditor',
    inputs: inputs,
    outputs: outputs,
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
    queries: {

    }
})
@ComponentMixins([ComponentBase])
export class RecurrenceEditorComponent extends RecurrenceEditor implements IComponentBase, OnInit, AfterViewInit, OnDestroy, AfterContentChecked {
    public context: any;
    public tagObjects: any;

    constructor(private ngEle: ElementRef, private viewContainerRef: ViewContainerRef) {
      super();
      this.element = this.ngEle.nativeElement;
      this.injectedModules = this.injectedModules || [];

      this.registerEvents(outputs);
      this.addTwoWay.call(this, twoWays);
      setValue('currentInstance', this, this.viewContainerRef);
      this.context  = new ComponentBase();

      const self: any = this;

      self.getEndData = (): { [key: string]: string }[] => {
        const endData: string[] = ['until', 'count'];
        const dataSource: { [key: string]: string }[] = [];
        endData.forEach((data: string) => {
            dataSource.push({ text: this.localeObj.getConstant(data), value: data });
        });
        return dataSource;
      };

      self.updateEndOnForm = (state: string): void => {
        state = state === 'never' ? 'until' : state;
        self.endType.setProperties({ value: state });
        switch (state) {
          case 'until':
            ['e-end-on-count'].forEach((className: string) => addClass([this.element.querySelector('.' + className)], 'e-hide-recurrence-element'));
            break;
          case 'count':
            ['e-end-on-date'].forEach((className: string) => addClass([this.element.querySelector('.' + className)], 'e-hide-recurrence-element'));
            break;
        }
      };
    }

    public ngOnInit() {
        this.context.ngOnInit(this);
    }

    public ngAfterViewInit(): void {
        this.context.ngAfterViewInit(this);
    }

    public ngOnDestroy(): void {
        this.context.ngOnDestroy(this);
    }

    public ngAfterContentChecked(): void {

        this.context.ngAfterContentChecked(this);
    }

    public registerEvents: (eventList: string[]) => void;
    public addTwoWay: (propList: string[]) => void;
}



// WEBPACK FOOTER //
// ./src/app/shared/components/recurrence-editor/recurrence-editor.component.ts